// src/components/CustomCard/CustomCardImage.tsx
import React from "react";

interface CustomCardImageProps {
  src: string;
  alt: string;
  className?: string;
  onClick?: () => void; // Optional click handler
}

const CustomCardImage: React.FC<CustomCardImageProps> = ({
  src,
  alt,
  className = "",
  onClick, // Destructure the onClick handler
}) => (
  <img
    src={src}
    alt={alt}
    className={`custom-card-image ${className}`}
    onClick={onClick} // Attach the handler
    role={onClick ? "button" : undefined} // For accessibility
    tabIndex={onClick ? 0 : undefined} // Add tab focus for accessibility
  />
);

export default CustomCardImage;
